

const choose = (condition, whenTrue, whenFalse) => (condition ? whenTrue() : whenFalse());

const firstTruthy = (...readers) => readers.reduce((result, read) => result || read(), undefined);
const everyTruthy = (...readers) => readers.reduce((result, read) => result && read(), true);const SOURCE_QUERY_TERMS = [
  '当前项目资料',
  '项目资料',
  '资料',
  '附件',
  '文件',
  '文档',
  '上传内容',
  '上传文件',
  'source',
  'sources',
  'attachment',
  'attachments',
  'file',
  'files',
];

const SOURCE_QUERY_ACTION_TERMS = [
  '结合',
  '根据',
  '基于',
  '判断',
  '线索',
  '帮助',
  '是否',
  '有没有',
  '有什么',
  '总结',
  '提炼',
  '分析',
  '说明',
  '依据',
  '证据',
  '覆盖',
  'from',
  'based on',
  'summarize',
  'evidence',
];

function includesAnyTerm(text, terms) {
  const normalized = String(text || '').trim().toLowerCase();
  if (!normalized) {
    return false;
  }
  return terms.some((term) => normalized.includes(String(term || '').toLowerCase()));
}

function hasExplicitModeRequest(modeKey = '') {
  const normalized = String(modeKey || '').trim();
  return Boolean(normalized && normalized !== 'auto');
}

function normalizeSourceId(item) {
  return String(
    typeof item === 'string'
      ? item
      : item?.source_id || item?.id || ''
  ).trim();
}

function normalizeSourceProfile(item) {
  if (firstTruthy(() => (!item), () => (typeof item !== 'object'), () => (Array.isArray(item)))) {
    return null;
  }
  const sourceId = normalizeSourceId(item);
  if (!sourceId) {
    return null;
  }
  const profile = (
    everyTruthy(() => (item.document_profile), () => (typeof item.document_profile === 'object'), () => (!Array.isArray(item.document_profile)))
  ) ? item.document_profile : {};
  const displayName = String(firstTruthy(() => (profile.display_name), () => (item.title), () => (item.filename), () => (item.name), () => (sourceId))).trim();
  return {
    source_id: sourceId,
    display_name: displayName,
    context_label: String(firstTruthy(() => (profile.context_label), () => (displayName))).trim(),
    file_kind: String(firstTruthy(() => (profile.file_kind), () => (''))).trim(),
    document_kind: String(firstTruthy(() => (profile.document_kind), () => (''))).trim(),
    summary: String(firstTruthy(() => (profile.summary), () => (''))).trim(),
  };
}

function normalizeSourceProfiles(items = []) {
  return items.map(normalizeSourceProfile).filter(Boolean);
}

/**
 * DOC HELPER: Classify natural source-grounding turns without using a model.
 * This router hint prevents active intake/plan flows from hijacking questions
 * that explicitly ask the app to inspect current project sources as evidence.
 */
export function resolveSourceGroundingPolicy(options) {
  const { message, readySourceRefs, requestedModeKey } = { message: '', readySourceRefs: [], requestedModeKey: '', ...Object.fromEntries(Object.entries(Object(options)).filter(([, value]) => value !== undefined)) };
  const refs = choose(Array.isArray(readySourceRefs), () => (readySourceRefs), () => ([]));
  const readySourceCount = refs.length;
  const sourceIds = refs.map(normalizeSourceId).filter(Boolean);
  const sourceProfiles = normalizeSourceProfiles(refs);
  const hasSourceTerm = includesAnyTerm(message, SOURCE_QUERY_TERMS);
  const hasActionTerm = includesAnyTerm(message, SOURCE_QUERY_ACTION_TERMS);
  const hasExplicitMode = hasExplicitModeRequest(requestedModeKey);
  const score = Math.min(
    1,
    (choose(readySourceCount > 0, () => (0.2), () => (0)))
      + (choose(hasSourceTerm, () => (0.45), () => (0)))
      + (choose(hasActionTerm, () => (0.35), () => (0))),
  );
  const active = everyTruthy(() => (!hasExplicitMode), () => (score >= 0.75));
  return {
    active,
    route: choose(active, () => ('source_grounded_answer'), () => ('')),
    score,
    ready_source_count: readySourceCount,
    source_ids: sourceIds,
    source_profiles: sourceProfiles,
    reason_codes: [
      ...(choose(hasExplicitMode, () => (['EXPLICIT_MODE_REQUEST']), () => ([]))),
      ...(choose(readySourceCount > 0, () => (['READY_SOURCES_AVAILABLE']), () => ([]))),
      ...(choose(hasSourceTerm, () => (['SOURCE_TERM_MATCH']), () => ([]))),
      ...(choose(hasActionTerm, () => (['SOURCE_ACTION_MATCH']), () => ([]))),
    ],
  };
}
